<template>
  <div>
    <div class="container-wrapper">
      <div class="content-wrapper" style="padding: 15px">
        <div style="margin-bottom: 12px; text-align: right">
          <el-button
            type="primary"
            :disabled="selectedRows.length === 0"
            @click="openBatchEdit"
            >批量编辑类型</el-button
          >
          <span
            style="margin-left: 10px; color: #999; font-size: 12px"
            v-if="selectedRows.length"
          >
            已选 {{ selectedRows.length }} 个一级菜单
          </span>
        </div>

        <el-table
          :data="visibleRows"
          ref="table"
          @selection-change="onSelectionChange"
          style="width: 100%"
        >
          <el-table-column
            type="selection"
            :selectable="(row) => row.level === 1"
            width="55"
          ></el-table-column>

          <el-table-column label="菜单名称" min-width="340">
            <template slot-scope="scope">
              <span
                :style="{
                  display: 'inline-block',
                  width: (scope.row.level - 1) * 24 + 'px',
                }"
              ></span>
              <i
                v-if="scope.row.hasChildren"
                class="el-icon-caret-right expand-icon"
                :class="{ expanded: scope.row.expanded }"
                @click="toggleExpand(scope.row)"
                style="cursor: pointer"
              ></i>
              <i
                v-else
                class="el-icon-caret-right"
                style="visibility: hidden"
              ></i>
              <span>{{ scope.row.node.title || scope.row.node.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="类型" width="140">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.node.campusScope === 1 ? 'success' : 'warning'"
                close-transition
              >
                {{
                  scope.row.node.campusScope === 1 ? "默认开放" : "指定学校开放"
                }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="已配置学校" width="140" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.level === 1 && scope.row.node.campusScope === 2"
                class="link-count"
                @click="openSchoolList(scope.row, 'applied')"
                >{{ scope.row.node.campusAppliedCount || 0 }}</span
              >
              <span v-else>—</span>
            </template>
          </el-table-column>

          <el-table-column label="已屏蔽学校" width="140" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.level === 1 && scope.row.node.campusScope === 1"
                class="link-count"
                @click="openSchoolList(scope.row, 'blocked')"
                >{{ scope.row.node.campusBlockedCount || 0 }}</span
              >
              <span v-else>—</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.level === 1"
                type="text"
                @click="openSingleEdit(scope.row)"
                >编辑</el-button
              >
              <span v-else>—</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 编辑类型弹窗 -->
    <el-dialog
      :title="editDialog.isBatch ? '批量编辑类型' : '编辑类型'"
      v-model="editDialog.visible"
      :modal-append-to-body="false"
      width="540px"
    >
      <el-form label-width="130px">
        <el-form-item label="适用类型">
          <el-row>
            <el-col :span="6">
              <el-radio v-model="editDialog.campusScope" :label="1"
                >默认开放</el-radio
              >
            </el-col>
            <el-col :span="6">
              <el-radio v-model="editDialog.campusScope" :label="2"
                >指定学校开放</el-radio
              >
            </el-col>
          </el-row>
        </el-form-item>
        <div style="color: #999; font-size: 12px; margin: -20px 20px 20px 20px">
          <template v-if="editDialog.campusScope === 1">
            默认开放：所有学校默认可见（含后续新增学校），仅所选学校被屏蔽（不选则全部可见）。
          </template>
          <template v-else>
            指定学校开放：仅所选学校可见，至少选择一所学校。
          </template>
        </div>
        <el-form-item
          :label="
            editDialog.campusScope === 1
              ? '屏蔽学校（选填）'
              : '开放学校（必选）'
          "
        >
          <el-select
            v-model="editDialog.selectedSchools"
            multiple
            filterable
            placeholder="请选择学校"
            style="width: 100%"
          >
            <el-option
              v-for="s in allSchools"
              :key="s.rootUnid"
              :label="s.name"
              :value="s.rootUnid"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="confirmEdit" :loading="saving"
          >确认修改</el-button
        >
      </span>
    </el-dialog>

    <!-- 已配置/已屏蔽学校列表弹窗 -->
    <el-dialog
      :title="schoolListDialog.title"
      v-model="schoolListDialog.visible"
      :modal-append-to-body="false"
      width="480px"
    >
      <div
        v-if="schoolListDialog.loading"
        style="text-align: center; padding: 24px; color: #999"
      >
        加载中...
      </div>
      <template v-else>
        <el-input
          v-model="schoolListDialog.keyword"
          placeholder="搜索学校"
          clearable
          style="margin-bottom: 12px"
        ></el-input>
        <div
          v-if="schoolListDisplay.length"
          style="max-height: 320px; overflow-y: auto"
        >
          <div
            v-for="(name, i) in schoolListDisplay"
            :key="i"
            style="padding: 10px 4px; border-bottom: 1px solid #f0f0f0"
          >
            {{ name }}
          </div>
        </div>
        <div v-else style="text-align: center; padding: 24px; color: #999">
          暂无学校
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="schoolListDialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "MenuManage",
  data() {
    return {
      menuTree: [],
      expandedIds: {},
      allSchools: [],
      selectedRows: [],
      editDialog: {
        visible: false,
        isBatch: false,
        menuIds: [],
        campusScope: 1,
        selectedSchools: [],
      },
      saving: false,
      schoolListDialog: {
        visible: false,
        title: "",
        loading: false,
        schools: [],
        keyword: "",
      },
    };
  },
  computed: {
    // 根据展开状态把树拍平为表格可见行
    visibleRows() {
      const result = [];
      const walk = (nodes, level) => {
        (nodes || []).forEach((node) => {
          const hasChildren = node.children && node.children.length;
          const expanded = !!this.expandedIds[node.id];
          result.push({
            id: node.id,
            level,
            node,
            hasChildren: !!hasChildren,
            expanded,
          });
          if (hasChildren && expanded) walk(node.children, level + 1);
        });
      };
      walk(this.menuTree, 1);
      return result;
    },
    // 弹窗内学校名单按关键词本地过滤（搜索框）
    schoolListDisplay() {
      const kw = (this.schoolListDialog.keyword || "").trim();
      if (!kw) return this.schoolListDialog.schools;
      return this.schoolListDialog.schools.filter(
        (name) => name && name.indexOf(kw) !== -1
      );
    },
  },
  methods: {
    fetchTree() {
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v1/menu/tree",
        dataType: "json",
        body: JSON.stringify({}),
      })
        .then((res) => {
          if (res.body && res.body.error === 10000) {
            this.menuTree = (res.body.data || []).map(this.normalizeNode);
          } else {
            this.$util.errorMsg(
              (res.body && res.body.message) || "获取菜单树失败"
            );
          }
        })
        .catch(() => this.$util.errorMsg("网络错误，获取菜单树失败"));
    },
    normalizeNode(node) {
      if (node.children) node.children = node.children.map(this.normalizeNode);
      return node;
    },
    fetchSchools() {
      this.$http({
        method: "GET",
        url: this.$util.domain + "/adminapi/v1/basicTools/allSchools",
      })
        .then((res) => {
          if (res.body && res.body.error === 10000) {
            const list = res.body.data || [];
            const seen = {};
            // 过滤无效项 + 按 rootUnid 去重（排除“全部”占位项 rootUnid=0），
            // 避免 el-option 重复 key / 重复 value 报错
            this.allSchools = list.filter((s) => {
              if (!s || s.rootUnid === undefined || s.rootUnid === null) {
                return false;
              }
              const key = Number(s.rootUnid);
              if (key === 0) return false;
              if (seen[key]) return false;
              seen[key] = true;
              return true;
            });
          }
        })
        .catch(() => {});
    },
    toggleExpand(row) {
      if (this.expandedIds[row.id]) {
        this.$delete(this.expandedIds, row.id);
      } else {
        this.$set(this.expandedIds, row.id, true);
      }
    },
    onSelectionChange(rows) {
      this.selectedRows = rows;
    },
    openSingleEdit(row) {
      this.editDialog.isBatch = false;
      this.editDialog.menuIds = [row.id];
      this.loadConfigAndOpen([row.id], row.node.campusScope);
    },
    openBatchEdit() {
      if (this.selectedRows.length === 0) return;
      this.editDialog.isBatch = true;
      this.editDialog.menuIds = this.selectedRows.map((r) => r.id);
      // 批量编辑不调用 /campus/config 预填：需要统一设置全部所选菜单的类型，
      // 没有单一“当前配置”可参考，直接以默认态打开弹窗即可
      this.editDialog.campusScope = 1;
      this.editDialog.selectedSchools = [];
      this.editDialog.visible = true;
    },
    // 拉取第一个菜单的学校配置用于预填，再打开弹窗
    loadConfigAndOpen(menuIds, defaultScope) {
      this.editDialog.campusScope = defaultScope || 1;
      this.editDialog.selectedSchools = [];
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v1/menu/campus/config",
        dataType: "json",
        body: JSON.stringify({ menuId: menuIds[0] }),
      })
        .then((res) => {
          if (res.body && res.body.error === 10000 && res.body.data) {
            const d = res.body.data;
            this.editDialog.campusScope = d.campusScope || defaultScope || 1;
            const wantType = this.editDialog.campusScope === 1 ? 1 : 2; // 1-屏蔽 2-应用
            this.editDialog.selectedSchools = (d.campusList || [])
              .filter((c) => c.type === wantType)
              .map((c) => c.rootUnid);
          }
        })
        .catch(() => {})
        .then(() => {
          this.editDialog.visible = true;
        });
    },
    // 点击“已配置学校/已屏蔽学校”数量，拉取该菜单的 campusList 并按 rootUnid 配对学校名称展示
    openSchoolList(row, kind) {
      if (row.level !== 1) return;
      this.schoolListDialog = {
        visible: true,
        title: kind === "applied" ? "已配置学校" : "已屏蔽学校",
        loading: true,
        schools: [],
        keyword: "",
      };
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v1/menu/campus/config",
        dataType: "json",
        body: JSON.stringify({ menuId: row.id }),
      })
        .then((res) => {
          this.schoolListDialog.loading = false;
          if (res.body && res.body.error === 10000 && res.body.data) {
            // campusList 中 type=2 为“应用（已配置）”，type=1 为“屏蔽”
            const wantType = kind === "applied" ? 2 : 1;
            const lookup = {};
            this.allSchools.forEach((s) => {
              lookup[Number(s.rootUnid)] = s.name;
            });
            this.schoolListDialog.schools = (res.body.data.campusList || [])
              .filter((c) => c.type === wantType)
              .map((c) => lookup[Number(c.rootUnid)])
              .filter((name) => !!name);
          }
        })
        .catch(() => {
          this.schoolListDialog.loading = false;
          this.schoolListDialog.schools = [];
        });
    },
    confirmEdit() {
      if (
        this.editDialog.campusScope === 2 &&
        this.editDialog.selectedSchools.length === 0
      ) {
        this.$util.errorMsg("指定学校开放时，请至少选择一个开放学校");
        return;
      }
      this.doSave();
    },
    doSave() {
      if (this.saving) return;
      this.saving = true;
      this.$http({
        method: "POST",
        url: this.$util.domain + "/adminapi/v1/menu/campus/save",
        dataType: "json",
        body: JSON.stringify({
          menuIds: this.editDialog.menuIds,
          campusScope: this.editDialog.campusScope,
          campusIds: this.editDialog.selectedSchools.map(Number),
        }),
      })
        .then((res) => {
          this.saving = false;
          if (res.body && res.body.error === 10000) {
            this.$util.successMsg("修改成功，已同步对应学校的菜单权限");
            this.editDialog.visible = false;
            this.selectedRows = [];
            this.expandedIds = {};
            this.fetchTree();
          } else {
            this.$util.errorMsg((res.body && res.body.message) || "保存失败");
          }
        })
        .catch(() => {
          this.saving = false;
          this.$util.errorMsg("网络错误，保存失败");
        });
    },
  },
  mounted() {
    this.fetchTree();
    this.fetchSchools();
  },
};
</script>

<style scoped>
.link-count {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}
.link-count:hover {
  color: #66b1ff;
}
.expand-icon {
  transition: transform 0.2s;
  margin-right: 4px;
}
.expand-icon.expanded {
  transform: rotate(90deg);
}
</style>



// WEBPACK FOOTER //
// MenuManage.vue?f25074c6